import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=174c2888&scoped=true"
import script from "./doc.vue?vue&type=script&lang=ts"
export * from "./doc.vue?vue&type=script&lang=ts"
import style0 from "./doc.vue?vue&type=style&index=0&id=174c2888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174c2888",
  null
  
)

export default component.exports